/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VideoSearchSortBy } from './videoSearchSortBy';


export interface VideoSearchQuery { 
    search_query?: string | null;
    title?: string | null;
    description?: string | null;
    date_start?: string | null;
    date_end?: string | null;
    duration_min?: number | null;
    duration_max?: number | null;
    status?: Array<VideoSearchQuery.StatusEnum> | null;
    gender?: Array<VideoSearchQuery.GenderEnum> | null;
    category?: Array<string> | null;
    competition?: Array<string> | null;
    championship?: Array<string> | null;
    sort_by?: Array<VideoSearchSortBy> | null;
    page?: number;
    page_size?: number;
}
export namespace VideoSearchQuery {
    export type StatusEnum = 'PENDING' | 'UPLOADING' | 'PROCESSING' | 'READY' | 'FAILED' | 'DELETED' | 'ARCHIVED' | 'RETIRED';
    export const StatusEnum = {
        Pending: 'PENDING' as StatusEnum,
        Uploading: 'UPLOADING' as StatusEnum,
        Processing: 'PROCESSING' as StatusEnum,
        Ready: 'READY' as StatusEnum,
        Failed: 'FAILED' as StatusEnum,
        Deleted: 'DELETED' as StatusEnum,
        Archived: 'ARCHIVED' as StatusEnum,
        Retired: 'RETIRED' as StatusEnum
    };
    export type GenderEnum = 'FEMENINO' | 'MASCULINO' | 'MIXTO' | 'NO ESPECIFICADO';
    export const GenderEnum = {
        Femenino: 'FEMENINO' as GenderEnum,
        Masculino: 'MASCULINO' as GenderEnum,
        Mixto: 'MIXTO' as GenderEnum,
        NoEspecificado: 'NO ESPECIFICADO' as GenderEnum
    };
}


